<template>
    <load v-if="loading" message="Carregando Midias" />
    <div v-else class="row">
        <div class="col-md-12">
            <div class="d-flex align-items-center justify-content-between">
                <h1 class="h3 mb-3 text-gray-800">
                    {{ $t("Gestão de Mídias") }}
                </h1>
                <div>
                    <button class="btn btn-primary" data-toggle="modal" @click="addMidia()">
                        <i class="fas fa-plus-square" />
                        Cadastrar
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <table class="table b-table mb-3 table-striped table-hover table-sm border b-table-stacked-md">
                <thead class="text-uppercase">
                    <tr>
                        <th style="width: 1%;"></th>
                        <th>Canal</th>
                        <th>Título</th>
                        <th>URL</th>
                        <th>Data</th>
                        <th style="width: 1%;"></th>
                        <th style="width: 1%;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item, key in midias" :key="key">
                        <td>
                            <i class="mdi mdi-movie"></i>
                        </td>
                        <td>{{ item.canal }}</td>
                        <td>{{ item.titulo }}</td>
                        <td><small>{{ item.url }}</small></td>
                        <td><small>{{ formatDate(item.created_at) }}</small></td>
                        <td>
                            <button class="btn btn-sm btn-primary" title="Editar" @click="editar(item)"
                                data-toggle="modal">
                                <i class="mdi mdi-pencil"></i>
                            </button>
                        </td>
                        <td>
                            <button class="btn btn-sm btn-danger" title="Excluir" @click="excluir(item.id)">
                                <i class="mdi mdi-delete midi-2x"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!--Modals-->
        <div class="modal" tabindex="-1" id="addMidia">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <span v-if="!midia.id">Incluir mídia</span>
                            <span v-if="midia.id">Editar mídia</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="canal">Canal</label>
                                    <select v-model="midia.canal" class="form-control" aria-describedby="canalHelp">
                                        <option value="suascast">Suascast</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="titulo">Título</label>
                                    <input type="text" v-model="midia.titulo" class="form-control" id="titulo"
                                        aria-describedby="tituloHelp">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="url">URL</label>
                                    <input type="text" v-model="midia.url" class="form-control" id="url"
                                        aria-describedby="urlHelp">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="descricao">Descrição</label>
                                    <textarea v-model="midia.descricao" class="form-control" id="descricao"
                                        aria-describedby="descricaoHelp"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="salvar()">
                            <span v-if="!midia.id">Salvar</span>
                            <span v-if="midia.id">Atualizar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default {
    props: [],
    components: {},
    name: "Read",
    data() {
        return {
            loading: true,
            load: true,
            midia: {},
            modal_midia: {},
            midias: [],
        };
    },
    mounted() {
        this.getMidias();
        /*
        this.midia.canal = 'suascast';
        this.midia.titulo = 'Teste de titulo';
        this.midia.descricao = 'Teste de descrição';
        this.midia.url = 'https://youtu.be/aYlPUlzlLEs?si=tX-MuTZrz7xs1L_C';
        */
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },
        addMidia() {
            //this.$bvModal.show("cadastrar-midia");
            this.midia = {};
            const modalElement = document.getElementById('addMidia');
            this.modal_midia = modalElement;
            if (modalElement) {
                const modal = new bootstrap.Modal(modalElement);
                this.modal_midia = modal;
                this.modal_midia.show();
            }
        },
        getMidias() {
            this.midiasLoading = true;
            axios
                .get(`api/dashboard/admin/midias`)
                .then((response) => {
                    this.midias = response.data;
                })
                .finally(() => {
                    this.loading = false;
                    this.load = false;
                });
        },
        salvar() {
            if (this.midia.id) {
                axios.put(`api/dashboard/admin/midias/${this.midia.id}`, this.midia)
                    .then(response => {
                        this.midia = {};
                        this.midias = this.midias.map(item => item.id === response.data.id ? response.data : item);
                        const modalElement = document.getElementById('addMidia');
			            this.modal_midia.hide();
                        this.$snack.success({ text: 'Mídia atualizada com sucesso!' });
                    })
                    .catch(errors => {
                        console.log('Ocorreu algum erro', errors);
                    })
            } else {
                axios.post(`api/dashboard/admin/midias`, this.midia)
                    .then(response => {
                        this.midia = {};
                        this.midias.unshift(response.data);
                        const modalElement = document.getElementById('addMidia');
			            this.modal_midia.hide();
                        this.$snack.success({ text: 'Mídia cadastrada com sucesso!' });
                    })
                    .catch(errors => {
                        console.log('Ocorreu algum erro', errors);
                    })
            }
        },
        excluir(id) {
            this.$bvModal.msgBoxConfirm('Tem certeza que deseja excluir esta mídia?', {
                title: 'Confirmação',
                size: 'md',
                buttonSize: 'md',
                okVariant: 'danger',
                okTitle: 'Sim',
                cancelTitle: 'Não',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.delete(`api/dashboard/admin/midias/${id}`)
                    .then(_ => {
                        this.midias = this.midias.filter(item => item.id !== id);
                        this.$snack.success({ text: 'Mídia excluída com sucesso!' });
                    })
                    .catch(errors => {
                        console.log('Ocorreu algum erro', errors);
                    })
                }
            })
        },
        editar(item) {
            this.midia = { ...item };
            const modalElement = document.getElementById('addMidia');
            this.modal_midia = modalElement;
            if (modalElement) {
                const modal = new bootstrap.Modal(modalElement);
                this.modal_midia = modal;
                this.modal_midia.show();
            }
        }
    },
};
</script>
<style>
@keyframes slideIn {
    0% {
        transform: translateY(-100%);
    }

    100% {
        transform: translateY(0);
    }
}

.modal-dialog {
    animation: slideIn 0.5s ease-out;
}
</style>